module.exports = __webpack_public_path__ + "static/media/Bike_Club_Logo.2e677e80.jpg";